export default require("../../node_modules/.pnpm/react-aria-menubutton@7.0.3_react@17.0.2/node_modules/react-aria-menubutton/dist/index.js");